/**
 * Enhanced encodeURIComponent.
 * Handles extra characters that encodeURIComponent does not encode.
 * @param str String to decode
 * @returns Decoded string
 *
 * @example
 * ```ts
 * const encoded = enhancedEncodeURIComponent('Hello%2C%20it%27s%20me%2C%20Hello%21');
 * console.log(encoded); // Hello, it's me, Hello!
 * ```
 */
export const enhancedEncodeURIComponent = (str: string) => {
	// encodeURIComponent does not parse these but they are not safe from form libraries
	return encodeURIComponent(str)
		.replace(/\./g, '%2E')
		.replace(/'/g, '%27')
		.replace(/\(/g, '%28')
		.replace(/\)/g, '%29')
		.replace(/\[/g, '%5B')
		.replace(/\]/g, '%5D');
};
